<!-- <app-license-server-expandable></app-license-server-expandable> -->
<div class="right-panel h-100">
  <div class="right-side h-100 d-flex flex-column postion-relative">
    <div class="hpc-action-bar d-flex flex-row mb-1 justify-content-end">
      <div class="flex-grow-1">
        <input
          title="Search by name, user or workstation"
          class="search float-start"
          type="text"
          placeholder="Search by name, user or workstation"
          [(ngModel)]="filterText"
          (ngModelChange)="onSearch()"
        />
      </div>
      <ng-select
        name="workstationFilter"
        class="hpc-filter-dropdown h-100 me-2"
        style="width: 10%"
        [(ngModel)]="filters.workstationSelected"
        [clearable]="false"
        [searchable]="false"
        (ngModelChange)="applyFilter()"
      >
        <ng-option value="all" title="All Actions">
          All Workstations
        </ng-option>
        <ng-option
          *ngFor="let workstation of filters.workstations"
          title="{{ workstation }}"
          value="{{ workstation }}"
        >
          {{ workstation }}
        </ng-option>
      </ng-select>
      <ng-select
        name="userFilter"
        class="hpc-filter-dropdown h-100 me-2"
        [(ngModel)]="filters.userSelected"
        style="width: 10%"
        [clearable]="false"
        [searchable]="false"
        (ngModelChange)="applyFilter()"
      >
        <ng-option value="all" title="All Types">All Users</ng-option>
        <ng-option
          *ngFor="let user of filters.users"
          title="{{ user }}"
          value="{{ user }}"
        >
          {{ user }}
        </ng-option>
      </ng-select>
      <button
        type="button"
        class="actionBtn"
        (click)="resetFilter()"
        #btnResetFilter
        triggers="hover" ngbTooltip="Reset applied Filters"
      >
        <span class="bi bi-x-lg text-danger"></span>
      </button>
      <button
        type="button"
        class="actionBtn"
        (click)="refreshComponent()"
        placement="top auto"
        triggers="hover" ngbTooltip="Refresh"
      >
        <span class="bi bi-arrow-clockwise"></span>
      </button>
    </div>
      <div
        #scrollableTable
        class="scrollableTable"
        [ngClass]="isDataAvailable ? 'flex-grow-1' : ''"
        style="white-space: nowrap; height: 75vh;"
      >
        <table
          class="table table-hover licenseListTable"
          dynamicPagination
          [rowHeight]="37"
          [offsetHeight]="calculatedOffsetHeight"
          [paginationInstance]="config"
        >
          <thead>
            <tr class="text-white h-auto table-list-head">
              <th scope="col" resizable>#</th>
              <th scope="col" resizable>Name</th>
              <th scope="col" resizable>
                Total
                <span style="cursor: pointer"
                      (click)="sortTotal()"
                      title="Sort Ascending/Descending"
                      [ngClass]="
                    filters.totalSort
                      ? 'bi-arrow-up-short'
                      : 'bi-arrow-down-short'
                  "
                      class="bi"></span>
              </th>
              <th scope="col" resizable>
                In Use
                <span style="cursor: pointer"
                      (click)="sortInUse()"
                      title="Sort Ascending/Descending"
                      [ngClass]="
                    filters.inUseSort
                      ? 'bi-arrow-up-short'
                      : 'bi-arrow-down-short'
                  "
                      class="bi"></span>
              </th>
              <!-- <th scope="col" resizable>Nodes/Workstations</th>
  <th scope="col" resizable>Users</th> -->
              <th scope="col" resizable>Machines</th>
              <th scope="col" resizable>Users</th>
            </tr>
          </thead>

          <tbody *ngIf="isDataAvailable">
            <tr
              class="hpc-cursor-pointer table-list-row"
              *ngFor="
                let license of filterLicenses
                  | paginate
                    : {
                        itemsPerPage: config.itemsPerPage,
                        currentPage: config.currentPage
                      };
                let i = index
              "
              style="height: 37px !important"
            >
              <td>
                {{
                  config.currentPage == 1
                    ? i + 1
                    : (config.currentPage - 1) * config.itemsPerPage + (i + 1)
                }}
              </td>
              <td>{{ license.licenseName }}</td>
              <td>{{ license.totalLicenses }}</td>
              <td>{{ license.inUseLicenses }}</td>
              <!-- <td class="text-break" *ngIf="license.stationName != ''">
                <select style="width: 150px">
                  <option
                    style="
                      width: 100%;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                    "
                    *ngFor="let stationName of license.stationName.split(',')"
                  >
                    {{ stationName }}
                  </option>
                </select>
              </td>
              <td class="text-break" *ngIf="license.stationName == ''">NA</td>
              <td class="text-break" *ngIf="license.userId != ''">
                <select style="width: 150px">
                  <option
                    style="
                      width: 100%;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                    "
                    *ngFor="let user of license.userId.split(',')"
                  >
                    {{ user }}
                  </option>
                </select>
              </td>

              <td class="text-break" *ngIf="license.userId == ''">NA</td> -->
              <td *ngIf="license.userId != ''" style="width: 400px">
                <form action="" [formGroup]="licenseForm">
                  <ng-select
                    #workstationLicense
                    [items]="license.licenseOnWorkstation"
                    [multiple]="true"
                    title="Workstation"
                    name="Workstation"
                    placeholder="Select Workstation"
                    [formControlName]="license.licenseName + '_' + 'ws'"
                    id=""
                    [closeOnSelect]="false"
                    [clearable]="false"
                    class="ngselect me-2"
                    (change)="onItemSelect($event, license, 'ws')"
                  >
                    <ng-template
                      ng-multi-label-tmp
                      let-items="items"
                      let-clear="clear"
                    >
                      <ng-container
                        *ngFor="
                          let item of licenseForm.get(
                            license.licenseName + '_' + 'ws'
                          ).value | slice : 0 : 1;
                          let i = index
                        "
                      >
                        <div class="ng-value" *ngIf="i < 1">
                          <span
                            class="ng-value-icon right"
                            (click)="clear(item)"
                            aria-hidden="true"
                            >×</span
                          >
                          <span class="ng-value-label">{{  item | shortenString:150 }}</span>
                        </div>
                      </ng-container>
                      <div
                        class="ng-value"
                        *ngIf="licenseForm.get(license.licenseName + '_' + 'ws').value.length > 1"
                      >
                        <span class="ng-value-label"
                          >+{{
                            licenseForm.get(license.licenseName + "_" + "ws")
                              .value.length - 1
                          }}
                          more...</span
                        >
                      </div>
                    </ng-template>
                  </ng-select>
                </form>
              </td>
              <td class="text-break" *ngIf="license.userId == ''">NA</td>
              <td *ngIf="license.userId != ''" style="width: 400px">
                <form action="" [formGroup]="licenseForm">
                  <ng-select
                    #userLicense
                    [items]="license.userUsingLicense"
                    [multiple]="true"
                    title="user"
                    name="user"
                    placeholder="Select User"
                    [formControlName]="license.licenseName + '_' + 'user'"
                    id=""
                    [closeOnSelect]="false"
                    [clearable]="false"
                    class="ngselect me-2"
                    (change)="onItemSelect($event, license, 'user')"
                  >
                    <ng-template
                      ng-multi-label-tmp
                      let-items="items"
                      let-clear="clear"
                    >
                      <ng-container
                        *ngFor="
                          let item of licenseForm.get(
                            license.licenseName + '_' + 'user'
                          ).value | slice : 0 : 2;
                          let i = index
                        "
                      >
                        <div class="ng-value" *ngIf="i < 1">
                          <span
                            class="ng-value-icon right"
                            (click)="clear(item)"
                            aria-hidden="true"
                            >×</span
                          >
                          <span class="ng-value-label">{{ item | shortenString:150 }}</span>
                        </div>
                      </ng-container>
                      <div
                        class="ng-value"
                        *ngIf="licenseForm.get(license.licenseName + '_' + 'user').value.length > 1"
                      >
                        <span class="ng-value-label"
                          >+{{
                            licenseForm.get(license.licenseName + "_" + "user")
                              .value.length - 1
                          }}
                          more...</span
                        >
                      </div>
                    </ng-template>
                  </ng-select>
                </form>
              </td>
              <td class="text-break" *ngIf="license.userId == ''">NA</td>
            </tr>
          </tbody>
        </table>
      </div>
    <div class="pagination-container d-flex justify-content-end align-items-center my-2">
      <pagination-controls
      *ngIf="isDataAvailable"
      class="my-pagination text-end"
      autoHide="true"
      (pageChange)="config.currentPage = $event"
      ></pagination-controls>
    </div>
    <div class="hpc-error-message-list" *ngIf="isDataAvailable == false">
      Licenses not found.
    </div>
    <ngx-spinner
      bdColor="rgba(0,0,0,0)"
      name="licenseInfoList"
      size="default"
      zIndex="1"
      color="var(--s-primary-color)"
      type="ball-spin"
      [fullScreen]="false"
      ><p class="pleaseWait">Please wait ...</p></ngx-spinner
    >
  </div>
</div>
